export default "__VITE_ASSET__BVRiqp3$__"